import { IconFooter } from 'app/components/common/iconFooter'
import { InquiryForm } from 'app/components/common/inquiryForm'
import { InquiryHeader } from 'app/components/common/inquiryHeader'
import React from 'react'
import PropTypes from 'prop-types'

import styles from './inquirySection.module.scss'

const InquirySection = ({ onConfirm, location, defaultClass }) => {
  const confirm = () => {
    if (typeof onConfirm === 'function') {
      onConfirm()
    }
  }

  const disclaimer =
    '100% Privacy Protection. No purchase necessary. By providing your contact details and ' +
    'clicking "Request a Free Quote" you consent to be contacted by our partner agents ' +
    'via phone and email to receive requested travel information. Opt out anytime.'

  const wrapperStyles = `${styles.inquirySection} ${location && styles[`${location}`]} `

  return (
    <div className={wrapperStyles}>
      <InquiryHeader className={styles.inquirySection__header} />
      <InquiryForm
        className={styles.inquirySection__form}
        onSubmitOk={() => confirm(true)}
        defaultClass={defaultClass}
      />
      <IconFooter className={`${styles.iconFooter}`}></IconFooter>
      <p className={`${styles.disclaimer}`}>{disclaimer}</p>
    </div>
  )
}

InquirySection.propTypes = {
  onConfirm: PropTypes.func,
  location: PropTypes.string,
  defaultClass: PropTypes.string,
}

export { InquirySection }
